export const toasterMessage = {
	loginFailed: {
		msg: "Please enter correct university ID!",
		color: "error",
	},
	wrongURLCredentials: {
		msg: "Please Select A valid University",
		color: "error",
	},
	incorrectField: (fieldName) => ({
		msg: `Incorrect ${fieldName}`,
		color: "error",
	}),
	incorrectUniqueId: {
		msg: "Please enter correct unique Id",
		color: "error",
	},
	incorrectUniversityId: {
		msg: "Please enter correct university Id",
		color: "error",
	},
	incorrectFairId: {
		msg: "Please select the event from the dropdown",
		color: "error",
	},
	notAuthorised: {
		msg: "Please Login To Continue...",
		color: "error",
	},
	cantUpdate: {
		msg: "Cant update this data!",
		color: "error",
	},
	reportUpdated: {
		msg: "Updated successfully",
		color: "success",
	},
	reportUpdateFail: {
		msg: "Failed to update",
		color: "error",
	},
	reportDownloadFail: {
		msg: "Failed to download",
		color: "error",
	},
};
